export type ChatFollowUp = string | { prompt: string; type: 'options'; options: string[] };

export type OnboardingQuestion =
  | { type: 'text'; key: string; prompt: string; emoji: string }
  | { type: 'options'; key: string; prompt: string; emoji: string; options: string[] }
  | { type: 'chat'; key: string; prompt: string; initialQuestion: string; followUps: ChatFollowUp[]; emoji: string };

export const onboardingQuestions: OnboardingQuestion[] = [
  {
    type: 'text',
    key: 'name',
    prompt: "Welcome! I'm ThinkMate, your momentum mentor.\n\nWhat would you like me to call you?",
    emoji: '😊',
  },
  {
    type: 'options',
    key: 'priority',
    prompt: "Hi {name}! I'm your daily companion for building unstoppable momentum. I'll check in with you regularly and help you stay on track with what matters most.\n\nWhat's your top priority for personal growth right now?",
    emoji: '🎯',
    options: [
      'Gain clarity on an idea or direction',
      'Set and achieve meaningful goals',
      'Gain insights through structured reflection',
      'Develop a creative and resilient mindset',
    ],
  },
  {
    type: 'options',
    key: 'blocker',
    prompt: "Which of these most often blocks your momentum?",
    emoji: '⛔',
    options: [
      'Clarity: Uncertainty about next steps',
      'Motivation: Difficulty maintaining drive',
      'Consistency: Irregular follow-through',
      'Accountability: Lack of commitment systems',
      'Focus: Easily distracted from priorities',
    ],
  },
  {
    type: 'options',
    key: 'support',
    prompt: "Which version of yourself are you most excited to become?",
    emoji: '🌟',
    options: [
      'A visionary founder or entrepreneur',
      'A confident creative or artist',
      'A powerful leader or change-maker',
      'Grounded, clear, and consistent',
    ],
  },
  {
    type: 'options',
    key: 'style',
    prompt: "What kind of mentorship brings out your best?",
    emoji: '🧑‍🏫',
    options: [
      'Encouraging with gentle guidance',
      'Firm and focused with direct feedback',
    ],
  },
  {
    type: 'chat',
    key: 'firstEntry',
    prompt: `Excellent! Let's complete your first check-in.

This is where your momentum truly begins.
Everything you write is private and only visible to you.

I understand your top priority is {priority}.

What's been weighing on your mind lately, even a little?`,
    initialQuestion: `I understand your top priority is {priority}.

What's been weighing on your mind lately, even a little?`,
    followUps: [
      "What's one small thing you could do for yourself today that no one's asking for?",
      "What's something coming up, even tiny, that you actually feel good about?"
    ],
    emoji: '🚀',
  },
]; 